"use client";

import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";
import Link from "next/link";
import { useRouter, usePathname } from "next/navigation";
import { useTranslations, useLocale } from "next-intl";
import { TryFreeButton } from "@/components/root/try-free-button";
import { useState } from "react";

export function MobileMenu() {
  const t = useTranslations("nav");
  const locale = useLocale();
  const [isOpen, setIsOpen] = useState(false);
  const router = useRouter();
  const pathname = usePathname();

  const isLanding = pathname.match(/^\/[a-z]{2}$/);

  const handleSectionClick = async (elementId: string) => {
    setIsOpen(false);

    if (!isLanding) {
      await router.push(`/${locale}`);
      setTimeout(() => {
        const element = document.getElementById(elementId);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    } else {
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  };

  return (
    <div className="flex items-center space-x-2 md:hidden">
      <TryFreeButton />
      <Sheet open={isOpen} onOpenChange={setIsOpen}>
        <SheetTrigger asChild>
          <Button variant="ghost" className="hover:bg-gray-100">
            <Menu className="h-6 w-6" />
          </Button>
        </SheetTrigger>
        <SheetContent className="w-[300px]">
          <nav className="flex flex-col space-y-4">
            <button
              onClick={() => handleSectionClick("faq")}
              className="text-lg text-left hover:text-gray-600"
            >
              {t("faq")}
            </button>
            <button
              onClick={() => handleSectionClick("features")}
              className="text-lg text-left hover:text-gray-600"
            >
              {t("features")}
            </button>
            <Link
              href={`/${locale}/blog`}
              className="text-lg hover:text-gray-600"
            >
              {t("blog")}
            </Link>
            <Link
              href={`/${locale}/contacts`}
              className="text-lg hover:text-gray-600"
            >
              {t("contacts")}
            </Link>
            <div className="pt-4">
              <TryFreeButton />
            </div>
          </nav>
        </SheetContent>
      </Sheet>
    </div>
  );
}
